import React, { useState } from 'react'
import { formatDate, ROUTES } from '../../shared/constants'
import CustomTableLayout from '../../components/CustomComponents/CustomTableLayout'
import { useQuery, useQueryClient } from 'react-query'
import { deleteDocumentById, getAllData } from '../../lib/RestApi/customApiHandler'
import useDebounce from '../../hooks/useDebounce'

export default function BusinessCategory() {
  const [searchQuery, setSearchQuery] = useState('')
  const debouncedValue = useDebounce(searchQuery, 500)
  let { data: businessCategory, isLoading } = useQuery(['business-category', debouncedValue && debouncedValue], () => getAllData('/business-category', { searchQuery: debouncedValue }))

  const queryClient = useQueryClient()

  let tmpArr = []
  if (!isLoading && businessCategory?.data?.length > 0) {
    businessCategory.data.map((item) => {
      return tmpArr.push([{ type: 'CHECKBOX', _id: item._id }, { value: item.name }, { value: formatDate(item.createdAt) }])
    })
  }

  const layoutProps = {
    heading: 'Manage Business Category',
    url: ROUTES.ADD_BUSINESS_CATEGORY,
    editUrl: 'edit-business-category/',
    searchQuery: searchQuery,
    setSearchQuery: setSearchQuery,
    // tempHeaders: tempHeaders,
    // tempHeaderData: [],
    // filename: 'moduleAdmins',
    // sampleName: 'sample_moduleAdmins',
    // sheetName: 'moduleAdmin',
    // headers: pdfCsvData.headings,
    // data: pdfCsvData.headingValues,
    // downloadLoading,
  }

  const deleteMany = async (ids) => {
    for await (let id of ids) {
      deleteDocumentById('/business-category', id)
    }
    queryClient.invalidateQueries('business-category')
  }

  return (
    <CustomTableLayout
      tableHeadings={['Business Category Name', 'Created At']}
      loading={isLoading}
      tableBody={tmpArr}
      // handleSwitchChange={handleSwitchChange}
      // handlePageChange={handleChange}
      // paginate={{ totalPage: noOfPages, page: page }}
      layoutProps={layoutProps}
      checkbox
      deleteMany={(val, setSelected) => {
        deleteMany(val)
        setSelected([])
      }}
    />
  )
}
